<template>
  <b-card>
    <div class="col-sm-12">
      <h4 class="h4-title">{{text.unit}}</h4>
      <b-row>
        <b-col
          class="form-group"
          cols="4"
        >
          <label for="formGroupExampleInput">{{text.unitNumber}}</label>
          <input
            type="text"
            class="form-control"
            id="unitNumber"
            :placeholder="text.unitNumber"
            v-model="Unit.unitNumber"
            required
          >
        </b-col>
      </b-row>
      <b-row>

            <div class="col-lg-12">
              <b-alert
                variant="success"
                dismissible
                fade
                :show="saveDone"
              >
                {{successMessage}}
              </b-alert>
              <b-alert
                variant="danger"
                dismissible
                fade
                :show="saveError"
              >
                {{errorMessage}}
              </b-alert>
            </div>

      </b-row>
      <b-row>
        <b-col
          class="form-group"
          cols="2"
        >
          <button
            type="button"
            class="btn action-b-btn b-btn" @click="saveUnit"
          >{{saveBtnCaption}}</button>
        </b-col>
        <b-col class="form-group" cols="2" >
          <button
            type="button"
            class="btn btn-back b-btn"
            @click="backToProfile"
          >{{backBtnCaption}}</button>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>
<script>
import MqdcOneClient from '@/models/mqdc-one-client';
import { textResident } from '@/assets/utils/language';
export default {
  name: 'UnitResident',
  props: ['id', 'projectcode', 'unitId'],
  data () {
    return {
      Unit: {
        unitNumber: ''
      },
      pageTitle: 'Unit',
      saveBtnCaption: 'Save',
      backBtnCaption: 'Back',
      deleteBtnCaption: 'Delete',
      saveDone: false,
      saveError: false,
      editMode: false,
      successMessage: '',
      errorMessage: '',
      mqdcOneClient: {},
      text: {}
    };
  },
  created: function () {
    this.mqdcOneClient = new MqdcOneClient(this.axios);
    document.title = 'One App: Resident: Unit';
    this.setEditUnit();
  },
  methods: {
    saveUnit () {
      if (!this.Unit.unitNumber) {
        this.saveError = true;
        this.errorMessage = 'Please enter unit information to save.';
        return false;
      }
      const unit = {
        'unitNumber': this.Unit.unitNumber
      };
      if (!this.editMode) {
        const url = `${process.env.VUE_APP_URL_MQDCONE_API}/mqdc-one/residents/${this.id}/projects/${this.projectcode}/units`;
        try {
          this.mqdcOneClient.getAxios().then(axios => {
            axios.post(
              url, unit).then(response => {
              this.successMessage = response.data.message;
              this.saveDone = true;
              this.backToProfile();
            })
              .catch(error => {
                this.saveError = true;
                this.saveDone = false;
                this.successMessage = '';
                this.errorMessage = error.response.data.message;
                console.log(error.response.data);
              });
          });
        } catch (err) {
          console.log(err);
        }
      } else {
        const url = `${process.env.VUE_APP_URL_MQDCONE_API}/mqdc-one/residents/${this.id}/projects/${this.projectcode}/units/${this.unitId}`;
        try {
          this.mqdcOneClient.getAxios().then(axios => {
            axios.patch(
              url, unit).then(response => {
              this.successMessage = response.data.message;
              this.saveDone = true;
              this.backToProfile();
            })
              .catch(error => {
                this.saveError = true;
                this.saveDone = false;
                this.successMessage = '';
                this.errorMessage = error.response.data.message;
                console.log(error.response.data);
              });
          });
        } catch (err) {
          console.log('Error : ', err);
        }
      }
    },
    setEditUnit () {
      if ('one_app_residents-unit-edit' === this.$route.name) {
        this.editMode = true;
        this.saveBtnCaption = this.text.edit;
        this.Unit.unitNumber = sessionStorage.getItem('unitnumber');
      }
    },
    backToProfile () {
      this.$router.push({ name: 'one_app_residents-edit', params: { id: this.id } });
    }
  },
  mounted () {
    this.text = textResident(this.$language);
    this.saveBtnCaption = this.text.save;
    this.backBtnCaption = this.text.back;
  },
  watch: {
    $language: function () {
      this.text = textResident(this.$language);
      this.saveBtnCaption = this.text.save;
      this.backBtnCaption = this.text.back;
    }
  }
};
</script>
<style scoped src="@/assets/css/projectunit.css"></style>
